module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_ZEITGARD.c4f14b02.png";